/* eslint-disable */
export default {
  noActiveCalls: '无进行中的通话',
  noCalls: '找不到结果。',
  currentCall: '当前通话',
  ringCall: '正在振铃通话',
  onHoldCall: '处于暂候状态的通话',
  historyCalls: '过去的通话',
  otherDeviceCall: '我的其他设备上正在进行的通话',
  searchPlaceholder: '搜索…',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
